import React from 'react';
import './i18n';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'api/queryClient';
import ThemeModeProvider from 'theme/ThemeModeProvider';
import './index.css';
import App from './App';
import { installKnowledgeNavigationBoundary } from './pages/console/assistant/knowledgeNavigationBoundary';

installKnowledgeNavigationBoundary();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeModeProvider>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ThemeModeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
